import { Text, View } from 'react-native'
import { Avatar } from '@chillout/ui'

interface CashierConfirmCardProps {
  name: string
  roleLabel: string
}

export function CashierConfirmCard({ name, roleLabel }: CashierConfirmCardProps) {
  return (
    <View className="rounded-lg border border-border bg-canvas-primary p-4">
      <View className="flex-row items-center gap-3">
        <Avatar name={name} size={48} />
        <View className="gap-0.5">
          <Text className="text-sm font-semibold text-primary">{name}</Text>
          <Text className="text-sm font-normal text-secondary">{roleLabel}</Text>
        </View>
      </View>
    </View>
  )
}